import { rangeWithDefaultsWhenEmpty } from '../engine/default-handlers';
import { defineFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

const DEFAULT_MIN_GROWTH_RATE = 0;
const DEFAULT_MAX_GROWTH_RATE = 25;

export const growthRateDescriptor = defineFilter({
  definition: {
    id: FilterId.GROWTH_RATE,
    name: 'Growth Rate',
    type: FilterType.RANGE,
    min: DEFAULT_MIN_GROWTH_RATE,
    max: DEFAULT_MAX_GROWTH_RATE,
    isActive: false,
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_GROWTH_RATE, segmented: true },
  handler: rangeWithDefaultsWhenEmpty(
    DEFAULT_MIN_GROWTH_RATE,
    DEFAULT_MAX_GROWTH_RATE
  ),
});
